import { oldRequest } from "./complexRequest"
import { PageData, PageQueryFn, PageResponse, ResponseType } from "./type"

// 签到
export const signIn = async (data: any = {}, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/signInV2',
    data,
    ...option
  }, useFetch)
}

// 获取签到数据
export const getSignInData = async (data: any = {}, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/signInDataV2',
    data,
    ...option
  }, useFetch)
}


// 获取用户 邀请搭档 数据
export const getUserIntimateData = async (data: any = {}, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/signInviteData',
    data,
    ...option
  }, useFetch)
}

// 邀请组队
export const inviteIntimate = async (data:
  {
    invite_code: string
  }, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/inviteGroup',
    data,
    ...option
  }, useFetch)
}

// 被邀请组队列表
export const getInviteList: PageQueryFn<any> = async (data: any, option = {}, useFetch = true) => {
  return oldRequest<PageResponse>({
    url: '/Api/signIn/inviteList',
    data,
    ...option
  }, useFetch)
}


// 同意·组队邀请
export const acceptInvite = async (data:
  {
    id: string
  }, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/acceptGroup',
    data,
    ...option
  }, useFetch)
}


// 拒绝·组队邀请
export const rejectInvite = async (data:
  {
    id: string
  }, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/rejectGroup',
    data,
    ...option
  }, useFetch)
}

// 解除好友关系
export const unlinkIntimate = async (data = {}, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/unlinkGroup',
    data,
    ...option
  }, useFetch)
}

// 取消解除好友关系
export const undoUnlinkIntimate = async (data = {}, option = {}, useFetch = true) => {
  return oldRequest<ResponseType<any>>({
    url: '/Api/signIn/undoUnlinkGroup',
    data,
    ...option
  }, useFetch)
}